<template>
        <div>
                <div  style="margin:0 5px">
                        <span class="title">服务项目</span>
                        <el-button v-show="isEdit" size="small" type="primary" @click="openSelectServiceProject">编 辑</el-button>
                </div>
                <div style="margin-top:35px">
                        <avue-crud
                                :option="option"
                                :data="checked"
                                id="serviceProject20211206"
                                
                        >
                        <template slot="price" slot-scope="scope">
                                {{scope.row.price?tool.money_format_allowvoid(scope.row.price) :'0.00'}}
                        </template>
                        <template slot="totalScore" slot-scope="scope">
                                {{Number(scope.row.score)*Number(scope.row.consumeNum)}}
                        </template>
                        <template slot="totalPrice" slot-scope="scope">
                                {{scope.row.price?tool.money_format_allowvoid(Number(scope.row.price)*Number(scope.row.consumeNum)) :'0.00'}}
                        </template>
                        </avue-crud>
                        <div style="margin:0 5px;height:0px">
                                <div class="totalScore">
                                        <span style="margin-right:10px">
                                                总计得分: {{totalScore}}

                                        </span>
                                </div>
                        </div>
                        
                </div>
                <!-- 编辑服务项目 -->
                <editServiceProject
                        :checked.sync="checked"
                        @refresh="refresh"
                        ref="editServiceProject"
                ></editServiceProject>
        </div>
</template>
<script>
import editServiceProject from "../repair/edit-service-project";
export default {
        components:{editServiceProject},
        props:{
                checked:{
                        type:Array,
                        default:()=>{
                                return [];
                        }
                },
                orderDetailForm:{
                        type:Object,
                        default:()=>{
                                return {};
                        }
                },
                isEdit:{
                        type:Boolean,
                        default:true,
                }
        },
        watch:{
                checked(val){
                        console.log('12345++')
                        console.log(val)
                        let totalScore = 0;
                        val.forEach(ele => {
                                totalScore += Number(ele.score)*Number(ele.consumeNum);
                        });
                        this.totalScore = totalScore;
                }
        },
        data(){
                return{
                        totalScore:0,
                        option:{
                                header:false,
                                index:true,
                                menu:false,
                                border:true,
                                stripe:true,
                                column:[
                                        {
                                                prop:'itemName',
                                                label:"服务类别",
                                                align:"left"
                                        },
                                        {
                                                prop:'serviceContent',
                                                label:"服务项目",
                                                align:"left"
                                        },
                                        {
                                                prop:'score',
                                                label:"分值",
                                                align:"left"
                                        },
                                        {
                                                prop:'price',
                                                label:"单价",
                                                align:"right",
                                                slot:true
                                        },
                                        {
                                                prop:'consumeNum',
                                                label:"数量",
                                                align:"left"
                                        },
                                        {
                                                prop:'totalScore',
                                                label:"小计得分",
                                                slot:true,
                                                align:"left"
                                        },
                                        {
                                                prop:'totalPrice',
                                                label:"小计金额",
                                                align:"right",
                                                slot:true
                                        }
                                ]
                        }
                }
        },
        methods:{
                refresh(){
                        this.$emit("refresh");
                },
                // 打开服务项目编辑框
                openSelectServiceProject(){
                        console.log(this.checked)
                        this.$refs.editServiceProject.openSelectTree(this.orderDetailForm,this.checked);

                },
        }
}
</script>
<style>
#serviceProject20211206 .el-table .cell{
        white-space: inherit;
}
</style>
<style lang="scss" scoped>
.title{
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 19px;
        color: #606266;
        font-size: 14px;
        margin-right: 34px;
}
.totalScore{
        position: relative;
        top: -47px;
        height: 48px;
        line-height: 48px;
        text-align: right;
        font-size: 14px;
        border: 1px solid #eee;
}
</style>>